export default __webpack_public_path__ + "2cd48ec8ab42051c3d185fda789a9118.png";